import React from "react";
import { Box, BoxProps } from "@mantine/core";
import styles from "./surface.module.css";

interface SurfacePaperProps extends BoxProps {
  children: React.ReactNode;
}

/**
 * White "paper" surface per the redesign: 20px radius, 22/24 padding
 * (16 on mobile), token shadow. Sits on the gray --surface-page background.
 */
export default function SurfacePaper({
  children,
  className,
  ...rest
}: SurfacePaperProps) {
  return (
    <Box
      className={className ? `${styles.paper} ${className}` : styles.paper}
      {...rest}
    >
      {children}
    </Box>
  );
}
